export function createAudioElement(uri: string): HTMLAudioElement {
  const audioElement = document.createElement('audio');
  audioElement.src = uri;
  audioElement.setAttribute('preload', 'none');
  audioElement.setAttribute('autoplay', 'false');
  document.body.appendChild(audioElement);
  return audioElement;
}
